import {create} from 'zustand'
import {devtools, persist} from 'zustand/middleware'
import * as React from "react";

type Store = {
  careInfo: {
    height: string, weight: string, bmi: number, interest_disease: string, work_strength: string, goal: string, food: string, reset: string
  }
}

const useStore = create<Store>()(
  devtools(
    persist(
      (set) => ({
        careInfo: {height: '', weight: '', bmi: 0, interest_disease: '', work_strength: '', goal: '', food: '', reset: ''},
        setCareInfo: (name: any, value: any) => set((state: any) => {
          state.careInfo[name] = value;
          return {}
        }),
      }),
      { name: 'careStore' },
    ),
  ),
)

export default useStore;